import { Expose } from 'class-transformer';
import { IsString } from 'class-validator';

export default class ImportSectionsUnitsData {
  @IsString()
  @Expose({ name: 'condominium_id' })
  readonly condominiumId: string;

  @IsString()
  readonly url: string;

  constructor(init?: ImportSectionsUnitsData) {
    this.condominiumId = init?.condominiumId!;
    this.url = init?.url!;
  }
}

